import React from "react";
import { LOGO_URL } from "../../config";
type BrandLogoProps = {
  className?: string;
  size?: "header" | "footer";
};
function BrandLogo({
  className = "",
  size = "header"
}: BrandLogoProps) {
  const frame = size === "footer" ? "h-[66px] w-[224px]" : "h-[48px] w-[172px] sm:h-[52px] sm:w-[188px] xl:w-[194px]";
  const image = size === "footer" ? "w-[350px]" : "w-[272px] sm:w-[296px] xl:w-[306px]";
  return <span className={`relative block shrink-0 overflow-hidden rounded-[8px] bg-pfpc-offwhite ${frame} ${className}`} data-id="element-174" data-mp="3ufau34pmidsh">
      <img src={LOGO_URL} alt="Perth Flat Pack Cabinets" className={`absolute left-1/2 top-1/2 h-auto max-w-none -translate-x-1/2 -translate-y-1/2 select-none ${image}`} draggable={false} data-id="element-175" data-mp="3pi11xhauno0y" />
    </span>;
}
export { BrandLogo };